import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const routes =[
  {
    path: '/',
    name: 'Home',
    component:resolve => require(['@/pages/Nhome'],resolve)//路由按需加载
  },
  //列表
  {
    path: '/List',
    name: 'List',
    component:resolve => require(['@/pages/NList'],resolve)
  },
  //详情
  {
    path: '/Detail',
    name: 'Detail',
    component:resolve => require(['@/pages/NDetail'],resolve)
  },
  //单位注册
  {
    path: '/Register',
    name: 'Register',
    component:resolve => require(['@/pages/Company/Register'],resolve)
  },
  //单位状态查询
  {
    path: '/SearchUnit',
    name: 'SearchUnit',
    component:resolve => require(['@/pages/Company/SearchUnit'],resolve)
  },
  //单位登录
  {
    path: '/UnitLogin',
    name: 'UnitLogin',
    component:resolve => require(['@/pages/Company/UnitLogin'],resolve)
  }, 
  //登录
  {
    path: '/Login',
    name: 'Login',
    component:resolve => require(['@/pages/Login'],resolve)
  }, 
  //单页
  {
    path: '/InfoShow',
    name: 'InfoShow',
    component:resolve => require(['@/pages/InfoShow'],resolve)
  },
  //搜索
  {
    path: '/Search',
    name: 'Search',
    component:resolve => require(['@/pages/Searchpage'],resolve)
  },
  //下载页面
  {
    path: '/DownLoad',
    name: 'DownLoad',
    component:resolve => require(['@/pages/DownLoad'],resolve)
  },
//   //处长信箱
//   {
//     path: '/MailBoxIndex',
//     name: 'MailBoxIndex',
//     component:resolve => require(['@/pages/MailBox/MailBoxIndex'],resolve)
//   },
  //大型招聘会
  {
    path: '/LargeList',
    name: 'LargeList',
    component:resolve => require(['@/pages/LargeRecruit/LargeList'],resolve)
  },
  //大型招聘详情
  {
    path: '/LargeDetail',
    name: 'LargeDetail',
    component:resolve => require(['@/pages/LargeRecruit/LargeDetail'],resolve)
  },
  //招聘单位详情
  {
    path: '/UnitDetail',
    name: 'UnitDetail',
    component:resolve => require(['@/pages/LargeRecruit/UnitDetail'],resolve)
  },
  //网络招聘列表
  {
    path: '/NetEmployList',
    name: 'NetEmployList',
    component:resolve => require(['@/pages/NetRecruit/NetEmployList'],resolve)
  },
  //网络招聘职位详情
  {
    path: '/NetDetail',
    name: 'NetDetail',
    component:resolve => require(['@/pages/NetRecruit/NetDetail'],resolve)
  },
  //专场招聘职位列表
  {
    path: '/RecruitList',
    name: 'RecruitList',
    component:resolve => require(['@/pages/SpecialRecruit/RecruitList'],resolve)
  },
  //专场招聘职位列表
  {
    path: '/RecruitDetail',
    name: 'RecruitDetail',
    component:resolve => require(['@/pages/SpecialRecruit/RecruitDetail'],resolve)
  },
  //档案查询
  {
    path: '/Enrollquery',
    name: 'Enrollquery',
    component:resolve => require(['@/pages/Enrollquery'],resolve)
  },
  //页面报错
  {
    path: '/NotFound',
    name: 'NotFound',
    component:resolve => require(['@/pages/NotFound'],resolve)
  },
  {
    path: '/NotFound4',
    name: 'NotFound4',
    component:resolve => require(['@/pages/NotFound4'],resolve)
  },
  {
    path: '/NotFound5',
    name: 'NotFound5',
    component:resolve => require(['@/pages/NotFound5'],resolve)
  },
]
const router =new Router({
  // mode:'history',
  routes, 
  // base: "/" + document.location.pathname.split('/')[1] + "/"
});

// 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到错误页面
router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
        next('/NotFound4') 
    }else {
        next() // 如果匹配到正确跳转
    }
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js